import { publicActionCreators } from './public/action-creators';
import { adminActionCreators } from './admin/action-creators';

import { AdminState } from './admin/slices';
import { PublicState } from './public/slices';

import { reducers as adminReducers } from './admin/reducers';
import { reducers as publicReducers } from './public/reducers';

export * from './public/actions';
export * from './admin/actions';

export interface RootState extends PublicState, AdminState {}

export const reducers = {
  ...publicReducers,
  ...adminReducers,
};

export interface EntityWithErrorState<T> {
  error: Error | null;
  loading: boolean;
  entity: T;
}

export const actionCreators = [...publicActionCreators, ...adminActionCreators];
